import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class IncidentService {

    constructor(private api: ApiService) { }

    list(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/incident/list`);
    }

    add(employeeId: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/${employeeId}/incident/add`, payload);
    }

    update(employeeId: number | string, incidentId: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/${employeeId}/incident/update/${incidentId}`, payload);
    }

    delete(employeeId: number | string, incidentId: number | string): Observable<any> {
        return this.api.delete(`hr/employee/${employeeId}/incident/${incidentId}`);
    }
}
